import { IAssetVehicleDVLAResult } from '../logic/api';

export function isAssetVehicleDVLAResult(value: unknown): value is IAssetVehicleDVLAResult {
  if (!value) {
    return false;
  }

  const castedValue = value as IAssetVehicleDVLAResult;

  if (
    castedValue.colour === 'undefined' ||
    castedValue.make === 'undefined' ||
    castedValue.model === 'undefined' ||
    castedValue.registration === 'undefined' ||
    castedValue.sourceFuelType === 'undefined' ||
    castedValue.sourceProvider === 'undefined'
  ) {
    return false;
  }

  return true;
}